import { render, staticRenderFns } from "./ModelPayee.vue?vue&type=template&id=b1f30cc2&scoped=true"
import script from "./ModelPayee.vue?vue&type=script&lang=js"
export * from "./ModelPayee.vue?vue&type=script&lang=js"
import style0 from "./ModelPayee.vue?vue&type=style&index=0&id=b1f30cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f30cc2",
  null
  
)

export default component.exports